import { makeStyles } from "@mui/styles";

const useUserInfoStyle = makeStyles(() => ({
  userInfoContainer: {
    top: 0,
    left: 0,
    height: "100vh",
    width: "18%",
    backgroundColor: "white",
    padding: 16,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "flex-start",
    boxShadow: "4px 0 10px -2px rgba(0, 0, 0, 0.1)",
    transition: "transform 300ms ease-in-out",
    zIndex: 40,
    position: "fixed",
  },
  userInfoContainerOpen: {
    transform: "translateX(0)",
    "@media (max-width: 899px)": {
      width: "50%",
    },
    "@media (min-width: 800px) and (max-width:898px)": {
      width: "20%",
      position: "fixed",
    },
  },
  userInfoContainerClosed: {
    "@media (max-width: 899px)": {
      transform: "translateX(-100%)",
    },
  },
  userInfoText: {
    textAlign: "left",
    marginTop: 20,
    width: "100%",
    "& p": {
      marginBottom: 8,
    },
  },
  profileImagecontainer: {
    width: "80%",
    margin: "0 auto",
    display: "flex",
    background: "#E0E0E2",
    borderRadius: "10px",
    paddingTop:'5px',
    paddingBottom:'5px'
  },
  profileImage: {
    maxWidth: "100%",
    aspectRatio: "1 / 1",
    borderRadius: "10px",
    margin: "auto",
  },
  responsiveText: {
    fontSize: "1rem", // Default font size
    "@media (min-width: 800px) and (max-width:898px)": {
      fontSize: "0.7rem !important", // 70% of original size
    },
  },
}));

export default useUserInfoStyle;
